function makeMap(str) {
  const map = /* @__PURE__ */ new Map();
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map.set(list[i], true);
  }
  return (val) => map.get(val);
}
makeMap(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
export {
  makeMap
};
